import Rest from '../../Rest'

export default class SystematicIntimidationService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/systematic_intimidation_config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

}
